module.exports = __webpack_public_path__ + "static/img/frack4.65fa4d2f.png";